import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';

/** Where the /apply wizard keeps its apply token. Per-tab, cleared on close. */
export const APPLY_TOKEN_KEY = 'rh_apply_token';

export function readApplyToken(): string {
  try {
    return sessionStorage.getItem(APPLY_TOKEN_KEY) || '';
  } catch (e) {
    // Private mode / storage blocked. No token is a normal state.
    return '';
  }
}

/*
 * /apply is the registration page, so those calls have no session behind them.
 * addFirstFormData issues a signed apply token bound to the applicant it
 * created; the server reads the applicant id out of it rather than trusting a
 * user_id in the query string. Sent whenever one is present - the server
 * ignores it for routes that do not ask for it, and a signed-in session always
 * takes precedence over it.
 */
@Injectable()
export class ApplyTokenInterceptor implements HttpInterceptor {

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const applyToken = readApplyToken();

    if (!applyToken) {
      return next.handle(req);
    }

    return next.handle(req.clone({ setHeaders: { 'X-Apply-Token': applyToken } }));
  }
}
